<template>
  <div>
    <base-title
      :title="'Automação de Marketing'"
      :subtitle="`Resultados de Aniversáriantes`"
      :link="'marketing'"
    >
      <base-button :text="'Filtrar por período'" :class="'shadow'" />
    </base-title>

    <div class="row">
      <div class="col-lg-3 col-xs-6">
        <base-box class="results-value">
          <p>R$ 41,20</p>
          <p>ticket médio</p>
        </base-box>
      </div>
      <div class="col-lg-3 col-xs-6">
        <base-box class="results-value">
          <p>R$ 216,80</p>
          <p>valor gasto</p>
        </base-box>
      </div>
      <div class="col-lg-3 col-xs-6">
        <base-box class="results-value">
          <p>R$ 1.222,95</p>
          <p>faturamento</p>
        </base-box>
      </div>
      <div class="col-lg-3 col-xs-6">
        <base-box class="results-value">
          <p>R$ 575,40</p>
          <p>de lucro</p>
        </base-box>
      </div>
    </div>

    <base-box class="funnel">
      <div class="row">
        <div class="col-lg-3 border-funnel">
          <div class="funnel-value">
            <p>1524</p>
            <p>Público alvo</p>
          </div>
        </div>
        <div class="col-lg-3 border-funnel">
          <div class="funnel-value">
            <p>1108</p>
            <p>Clientes impactados</p>
          </div>
        </div>
        <div class="col-lg-3 border-funnel">
          <div class="funnel-value">
            <p>328</p>
            <p>Clientes recuperados</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="funnel-value">
            <p>159</p>
            <p>Resgataram o cupom</p>
          </div>
        </div>
      </div>
    </base-box>

    <h3>Público da campanha</h3>

    <base-box>
      <base-input :label="'Pesquisar por cliente'" class="search" />
    </base-box>

    <div class="row">
      <div class="col-lg-4">
        <!-- v-for -->
        <base-box>
          <p>Cliente: Adryan Gonçalves</p>
          <p>Cliente á:</p>
          <p>Consumo na campanha:</p>
          <p>Consumo total:</p>
          <p>Data de uso:</p>
        </base-box>
      </div>
    </div>
  </div>
</template>
<script>
import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseBox from "@/components/Box";
import BaseInput from "@/components/Input";

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
  },
};
</script>

<style scoped>
.results-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.results-value p:first-child {
  color: var(--default);
  margin-right: 4px;
  font-size: 1.8em;
  font-weight: 600;
  opacity: 0.9;
}

.results-value p:last-child {
  color: #999;
  margin-left: 4px;
  font-size: 1.4em;
  font-weight: 300;
}

.funnel {
  padding: 60px 40px;
}

.funnel-value {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px 0;
}

.funnel-value p:first-child {
  font-size: 4em;
  color: var(--default);
  font-weight: 900;
  opacity: 0.9;
}

.funnel-value p:last-child {
  margin-top: 10px;
  font-size: 1.6em;
  font-weight: 300;
  color: #999;
}

.border-funnel {
  border-right: 1px solid #ddd;
}

h3 {
  margin: 50px 0 30px 0;
  color: #bbb;
  font-family: "Rubik", sans-serif;
  font-size: 1.6em;
}

.search {
  margin-bottom: 10px;
}

/* RESPONSIVO */
@media (max-width: 991px) {
  .results-value {
    align-items: center;
    flex-direction: column;
  }

  .funnel-value {
    padding: 35px 0;
  }

  .border-funnel {
    border: none;
  }

  .border-funnel::after {
    content: "";
    margin: 0 0.5em;
    display: inline-block;
    border: 7px solid transparent;
    border-top: 8px solid #ddd;
    border-bottom: 0 none;
    left: 47%;
    position: absolute;
  }
}
</style>